module.exports = __webpack_public_path__ + "static/media/48419303_2308814489193729_3627601842889818112_o-thumb.9455fb3a.jpg";